module.exports = __webpack_public_path__ + "img/pro-p-slider21.8b18efa2.png";